export default __webpack_public_path__ + "static/media/zodiac06.f6651424.png";